import { render } from "./Help.vue?vue&type=template&id=f5e840f6"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"
script.render = render

export default script